<template> <!-- logo image -->
  <div class="signup">
    <v-app id="signup">
      <v-content>
        <v-container fluid fill-height>
          <v-layout justify-center>
            <v-flex xs12 sm8 md8>
              <v-card class="elevation-12" v-if="userinc">
                <v-divider></v-divider>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t('already_filled') }}   
                  </v-toolbar-title>
                </v-toolbar>
                <v-toolbar>
                  <v-toolbar-title>
                    <div class="label">
                      <b>{{ $t('auth_email') }}:</b>{{email}}
                    </div>
                    <div class="label">
                      <b>{{ $t('auth_user') }}:</b>{{userinc.name}}
                    </div>
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-actions>
                  <router-link to="dashboard/home"><v-btn rounded color="success" class="mr-4"><v-icon>mdi-home</v-icon>{{ $t('navigation_dashboard') }}</v-btn></router-link>
                  <v-spacer></v-spacer>
                  <v-btn rounded color="indigo" dark @click="back"><v-icon>mdi-arrow-left-bold</v-icon>{{ $t('common_previous') }}</v-btn>
                </v-card-actions>
              </v-card>
              <v-card class="elevation-12" v-else>
                <v-toolbar color="indigo" dark flat>
                  <v-btn rounded color="indigo" dark @click="back"><v-icon>mdi-arrow-left-bold</v-icon>{{ $t('common_previous') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-toolbar-title> {{ $t('user_register') }} ({{ $t('step_two') }})</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  {{email}}
                </v-toolbar>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field label="UserName" prepend-icon="mdi-star" v-model="user_info.name" hint="Your User Name"></v-text-field>
                    </v-flex>
                    <v-flex xs4>
                      <v-btn @click.native="selectFile" v-if="!uploading" right large rounded color="black" dark width="100%">
                        User Logo
                        <v-icon >
                          mdi-camera mdi-24px
                        </v-icon>
                      </v-btn>
                      <v-btn @click.native="selectFile" v-if="uploading" right large rounded color="black" dark width="100%">
                        User Logo
                        <v-icon >
                          mdi-camera mdi-24px
                        </v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs2>
                      <form ref="form">
                          <input
                            type="file"
                            ref="uploadInput"
                            accept="image/*"
                            @change="uploadImage">
                      </form>
                      <v-progress-circular
                        v-if="uploading"
                        :size="50"
                        :width="7"
                        :rotate="360"
                        :value="progressUpload"
                        color="primary">
                        {{ progressUpload }}%
                      </v-progress-circular>
                    </v-flex>
                    <v-flex xs6 d-flex>
                      <div v-for="(image, index) in user_info.user_image" style="padding: 5px;" v-bind:key="image">
                        <v-card max-width="100" class="mx-auto">
                          <v-img height="100px" :src="image"></v-img>
                          <v-card-actions>
                            <v-btn text small color="error" @click="deleteImage(image, index)">Delete</v-btn>
                          </v-card-actions>
                        </v-card>
                      </div>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field label="First Name" prepend-icon="mdi-account" v-model="user_info.first_name" hint="Your First Name"></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field label="Last Name" prepend-icon="mdi-account" v-model="user_info.last_name" hint="Your Last Name"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field label="Phone Number" prepend-icon="mdi-phone" prefix="+26" v-model="user_info.phone" hint="097xxxxx, 096xxxxx, 095xxxxx"></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-autocomplete v-model="user_info.country" :items="country_code" dense attach chips filled label="Country Code" item-text="name" item-value="countryCode" prepend-icon="mdi-map"></v-autocomplete>
                    </v-flex><v-flex xs6>
                      <v-autocomplete v-model="user_info.town" :items="town_code" dense attach chips filled label="Town Code" item-text="name" item-value="name" prepend-icon="mdi-map"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-btn rounded color="error" class="mr-4" @click="reset">{{ $t('reset') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn rounded color="indigo" dark @click="register">{{ $t('register') }}</v-btn>
                </v-card-actions>              
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
  import {fb,db} from '@/firebase'

  export default {
    name: "signup",
    data: () => ({
      drawer: null,
      progressUpload: 0,
      uploading: false,
      userinc: null,
      town_code: [],
      country_code: [],
      user_info : {
        user_id: fb.auth().currentUser.uid,
        email: fb.auth().currentUser.email,
        name: '',
        first_name: '',
        user_image: [],
        last_name: '',
        country: '',
        town: '',
        phone: ''
      }
    }),
    firestore: {
      userprofile: db.collection('user'),
      country_code: db.collection('country_code'),
      town_code: db.collection('town_code')
    },
    methods: {
      selectFile () {
        this.$refs.uploadInput.click()
      },
      uploadImage(e){
        if(e.target.files[0]){
          this.uploading = true
          let file = e.target.files[0];
          var storageRef = fb.storage().ref('user_image/'+ Math.random() + '_' + file.name);
          let uploadTask = storageRef.put(file)
          uploadTask.on('state_changed', sp => {
            this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
          }, (error) => {
            /* eslint-disable no-console */
              console.log(error)
            /* eslint-enable no-console */
          }, () => {

            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.user_info.user_image.push(downloadURL)
              /* eslint-disable no-console */
                console.log('File available at', downloadURL);
              /* eslint-enable no-console */
            })  
          })
        }
      },
      deleteImage(img, index){
        let image = fb.storage().refFromURL(img);
        this.user_info.user_image.splice(index, 1);
        image.delete().then(() => {
          /* eslint-disable no-console */
            console.log('image deleted');
          /* eslint-enable no-console */
        }).catch((error) => {
          /* eslint-disable no-console */
            console.log(error)
          /* eslint-enable no-console */
        })
        this.$refs.form.reset()
      },
      reset () {
        this.user_info = {
          user_id: fb.auth().currentUser.uid,
          email: fb.auth().currentUser.email,
          name: '',
          first_name: '',
          user_image: [],
          last_name: '',
          country: '',
          town: '',
          phone: ''
        }
      },
      back(){
        this.$router.go(-1)
      },
      register(){
        this.$firestoreRefs.userprofile.add(this.user_info)
        .then(() => {
          /* eslint-disable */
        Toast.fire({
          type: 'success',
          title: 'User Registered Successfully'
        })
        /* eslint-enable */
        this.$router.replace('/dashboard/home')
        })
      }
    },
    created() {
      this.email = fb.auth().currentUser.email
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.userinc =doc.data(),
          this.userinc.id = doc.id//
        })
      })
    }
  }
</script>

<style scoped>
input[type="file"] {
  position: absolute;
  clip: rect(0,0,0,0);
}
</style>